import {
  Radio, Card, Divider, Input, InputNumber,
  Select, DatePicker, Button, Modal,
  notification, message, Form,
  Spin, Switch
} from 'antd';
import { useEffect, useState } from 'react'
import moment from 'moment';
import { format } from '../App'
import './sellPac.css'
import MenuBar from './menu/MenuBar';
import { useSelector, useDispatch } from "react-redux";
import { delUser, setUser } from '../app/features/user/userSlice';
import { getNamalData, postData } from '../data/allfunction';
import { useHistory } from 'react-router-dom';
import { db } from '../data/firebase'
import MakeDocSafty from './pdf/MakeDocSafty';
const ip = process.env.REACT_APP_IP

const { Option } = Select;
const dateFormat = 'DD-MM-YYYY HH:mm:ss'
// const dateFormat = 'YYYY-MM-DD HH:mm:ss'



function Sellpac() {
  const dispatch = useDispatch()
  const history = useHistory()
  const [form] = Form.useForm();
  const { token, retoken, user, user_id } = useSelector(state => {
    return state.user
  })
  const [modalsave, setmodalsave] = useState(false)
  const [listData, setlistData] = useState([])
  // -----------------
  const [o_name, seto_name] = useState('')
  // const [o_address, seto_address] = useState('')
  const [o_tel, seto_tel] = useState('')
  const [o_type, seto_type] = useState('')
  const [o_make, seto_make] = useState('')
  const [o_plate, seto_plate] = useState('')
  const [o_color, seto_color] = useState('')
  const [o_power, seto_power] = useState('')
  const [o_engine, seto_engine] = useState('')
  const [o_chassis, seto_chassis] = useState('')
  const [o_weight, seto_weight] = useState(0)
  const [o_seats, seto_seats] = useState(0)

  const [a_used, seta_used] = useState('private')
  const [a_type, seta_type] = useState('new')


  const [data, setdata] = useState([])
  const [premuim, setpremuim] = useState('')
  const [vat, setvat] = useState(7)
  const [register, setregister] = useState('')
  const [total_premuim, settotal_premuim] = useState('')

  const [startCover, setstartCover] = useState()
  const [endCover, setendCover] = useState()
  const [sent_startCover, setsent_startCover] = useState()
  const [sent_endCover, setsent_endCover] = useState()

  const [cover, setcover] = useState('')

  const [emp_paid, setemp_paid] = useState(0)
  const [modalShowPolicy, setmodalShowPolicy] = useState(false)
  const [no, setno] = useState(0)
  const [datasentPDF, setdatasentPDF] = useState(0)

  const [provice, setprovice] = useState([])
  const [dist, setdist] = useState([])
  const [proviceSelect, setproviceSelect] = useState('')
  const [proviceid, setproviceid] = useState(null)
  const [distSelect, setdistSelect] = useState('')
  const [villageSelect, setvillageSelect] = useState('')

  const [loadingPDF, setloadingPDF] = useState(false)
  const [package_id, setpackage_id] = useState(null)

  const [addEnd, setAddEnd] = useState(false)


  // --------------------

  function onChange_Car(value) {

    const d = data.filter(v => v.id === value)
    // console.log(d[0].registration)
    setcover(d[0].name)

    let t = d[0].premium
    let r = d[0].registration

    let v = ((t - r) * 7) / 107

    let p = t - r - v
    setpackage_id(value)
    // console.log(value)
    settotal_premuim(t)
    setregister(r)
    setvat(v)
    setpremuim(p)



  }
  function onChange_timestart(value, dateString) {
    setstartCover(moment(value).format(dateFormat))
    setsent_startCover(value)

    setendCover(moment(value).add(1, 'Y').subtract(1, 'd').format(dateFormat))
    // console.log(moment(value).add(1, 'Y').subtract(1, 'd').format(dateFormat))
    setsent_endCover(moment(value).add(1, 'Y').subtract(1, 'd'))
  }

  function onChange_timeend(value, dateString) {
    setendCover(moment(value).format(dateFormat))
    setsent_endCover(value)
  }







  const onReset = () => {
    form.resetFields();
  };
  const submitForm = (e) => {


    seto_name(e.name === undefined ? '' : e.name)
    setvillageSelect(e.addressVill === undefined ? '' : e.addressVill)
    setdistSelect(e.addressDist === undefined ? '' : e.addressDist)
    setproviceSelect(e.addressPro === undefined ? '' : e.addressPro)
    seto_tel(e.phone === undefined ? '' : e.phone)
    seto_type(e.typeCar === undefined ? '' : e.typeCar)
    seto_make(e.make === undefined ? '' : e.make)
    seto_plate(e.plate === undefined ? '' : e.plate)
    seto_color(e.color === undefined ? '' : e.color)
    seto_power(e.power === undefined ? '' : e.power)
    seto_engine(e.engine === undefined ? '' : e.engine)
    seto_chassis(e.chassis === undefined ? '' : e.chassis)
    seto_weight(e.weight === undefined ? '' : e.weight)
    seto_seats(e.seats === undefined ? '' : e.seats)

    // setsent_startCover(moment(e.start).format('YYYY-MM-DD HH:mm:ss'))
    // setsent_endCover(moment(e.end).format('YYYY-MM-DD HH:mm:ss'))


    // setsent_startCover(moment(e.start).format('YYYY-MM-DD HH:mm:ss'))
    // setsent_endCover(moment(e.end).format('YYYY-MM-DD HH:mm:ss'))


    setmodalsave(true)


  }
  function createPolicy() {
    let link = `${ip}sell_online/package`
    const dataSetForGet =
    {
      o_name: o_name,
      o_address: `${villageSelect} ເມືອງ ${distSelect} ແຂວງ ${proviceSelect}`,
      o_tel: o_tel,
      o_type: o_type,
      o_make: o_make,
      o_plate: o_plate,
      o_color: o_color,
      o_power: o_power,
      o_engine: o_engine,
      o_chassis: o_chassis,
      o_weight: o_weight,
      o_seats: o_seats,
      a_used: a_used,
      a_type: a_type,
      premuim: premuim,
      vat: vat,
      register: register,
      total_premuim: total_premuim,
      start: sent_startCover,
      end: sent_endCover,
      cover: cover,
      user_add: user_id,
      dateadd: Date.now(),
      emp_paid,
      package_id,
      driver_id: 3
    }

    function setWhenUpdate(result) {
      if (result.data.fieldCount === 0) {
        onReset()
        notification['success']({
          message: 'ແຈ້ງເຕືອນ',
          description: 'ບັນທຶກຂໍ້ມູນສຳເຫຼັດ'
        });
        setTimeout(() => {
          // const win = window.open(`${l}/docsafety/${result.data.insertId}`, "_blank");
          // win.focus();
          getOneData(result.data.insertId)
        }, 1000);
      } else {
        alert(JSON.stringify(result.data.message))
        console.log(result.data.message)
      }
    }

    if (sent_startCover === undefined || sent_endCover === undefined) {

      notification['error']({
        message: 'ແຈ້ງເຕືອນ',
        description: 'ກະລຸນາກວດສອບວັນທີການຄຸ້ມກັນ'
      });
    } else {
      alert(link)
      setmodalsave(false)
      postData(message, link, dataSetForGet, token, retoken, user, dispatch, delUser, setUser, history, setWhenUpdate)
      form.resetFields()

      // getOneData(1)
      // console.log(dataSetForGet)


    }
  }

  function getOneData(policy_no) {
    setloadingPDF(true)
    let link = `${ip}sell_online/getOne`
    let dataSetForGet = { no: policy_no, user: user_id }
    function setWhenUpdate(result) {
      if (result.data.status === 200) {
        setdatasentPDF(result.data.rows[0])
        setno(policy_no)
        setTimeout(() => {
          setmodalShowPolicy(true)
          // message.success(`ພົບເລກທີສັນຍາ ${policy_no} ໃນລະບົບ`);      
        }, 1000);
      } else {
        message.success(`ບໍ່ພົບເລກທີສັນຍາ ${policy_no} ໃນລະບົບ`);
        setloadingPDF(false)
      }

    }
    postData(message, link, dataSetForGet, token, retoken, user, dispatch, delUser, setUser, history, setWhenUpdate)
  }

  function packages() {
    var requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };


    fetch(ip + "sell_online/packages", requestOptions)
      .then(response => response.json())
      .then(result => {
        console.log(result)
        if (result.data.status === 200) {
          setdata(result.data.data)
        } else {
          setdata([])
        }

      })
      .catch(error => console.log('error', error));
  }


  function gettypeCar() {
    db.collection("ZJI")
      .orderBy("no", "asc")
      .get()
      .then(result => {
        let d = []
        result.forEach(doc => {
          d = ([...d, doc.data()])
        })
        setlistData(d)

      })
      .catch(e => console.log(e))
  }



  useEffect(() => {
    packages()
    gettypeCar()
  }, [])

  useEffect(() => {
    async function _pro() {
      let l = ip + "address/pro"
      let p = await getNamalData(l)
      p.status === 200 && setprovice(p.data)
    }
    _pro()
  }, [])


  useEffect(() => {
    async function _dist() {
      if (proviceid != null) {
        let l = ip + "address/dist/" + proviceid
        let d = await getNamalData(l)
        d.status === 200 && setdist(d.data)
      }
    }
    _dist()
  }, [proviceid])

  return (
    <>
      <MenuBar />
      {loadingPDF ? <Spinshow /> : Datashow()}
      <Modal
        title="ກວດຂໍ້ມູນໃຫ້ລະອຽດກ່ອນການບັນທືກ"
        visible={modalsave}
        closable={false}
        footer={[
          <Button key="ກັບຄືນ" onClick={() => setmodalsave(false)}>
            ກັບຄືນ
          </Button>,
          <Button key="ຕົກລົງ" onClick={createPolicy}>
            ຕົກລົງ
          </Button>

        ]}
      >
        <div className='B'>
          <div className='B1'> ຜູ້ໃດ້ຮັບການປະກັນໄພ </div>
          <div className='B2'>{o_name}</div>
        </div>
        <div className='B'>
          <div className='B1'> ເລກທະບຽນ </div>
          <div className='B2'>{o_plate}</div>
        </div>
        <div className='B'>
          <div className='B1'> ເລກຈັກ </div>
          <div className='B2'>{o_engine}</div>
        </div>
        <div className='B'>
          <div className='B1'> ເລກຖັງ </div>
          <div className='B2'>{o_chassis}</div>
        </div>
        <div className='B'>
          <div className='B1'> ການຄຸ້ມກັນ </div>
          <div className='B2'>{cover}</div>
        </div>
        <div className='B'>
          <div className='B1'> ວັນທີເລີ່ມຄຸ້ມກັນ </div>
          <div className='B2'>{startCover}</div>
        </div>
        <div className='B'>
          <div className='B1'> ວັນທີສຶ້ນສຸດຄຸ້ມກັນ </div>
          <div className='B2'>{endCover}</div>
        </div>
        <div className='B'>
          <div className='B1'> ລວມມູນຄ່າຕ້ອງຈ່າຍ </div>
          <div className='B2'>{format(total_premuim)}</div>
        </div>
        <div className='B'>
          <div className='B1'> ສະຖານະການຈ່າຍເງິນ </div>
          <div className='B2'> {emp_paid === 1 ? 'ຊຳລະສົມບູນ' : 'ລໍຖ້າການຊຳລະ'} </div>
        </div>
      </Modal>

      <Modal
        width={'720px'}
        title="ລາຍລະອຽດຂອງສັນຍາການຂາຍ"
        visible={modalShowPolicy}
        closable={false}
        //  onOk={() => setmodalShowPolicy(false)}
        // onCancel={() => setmodalShowPolicy(false)}
        footer={[
          <Button key="ກັບຄືນ" onClick={() => {
            setloadingPDF(false)
            setmodalShowPolicy(false)
          }}>
            ປິດ
          </Button>,

        ]}
      >

        <MakeDocSafty
          no={no}
          oneData={datasentPDF}
        />
      </Modal>

    </>
  );

  function Datashow() {
    return (
      <div className="container">
        <Form
          form={form}
          name="sellpac"
          // labelCol={{ span: 8 }}
          // wrapperCol={{ span: 16 }}
          initialValues={{ remember: true }}
          onFinish={submitForm}
          autoComplete="off"
        >
          <Card className='C'>
            <Divider orientation="left" plain>
              ຂໍ້ມູນຂອງຜູ້ໄດ້ຮັບການປະກັນໄພ
            </Divider>
            <Form.Item
              className='mb-0'
              // label="ຊື່ ແລະ ນາມສະກຸນ"
              name="name"
            >
              <Input className='TI' placeholder="ຊື່ ແລະ ນາມສະກຸນ"
                onChange={(e) => {
                  //  seto_name(e.target.value)
                }}
              />
            </Form.Item>


            <div className='row'>
              <div className='col'>
                <Form.Item
                  className='mb-0'
                  // label="ທີ່ຢູ່ແຂວງ"
                  name="addressPro"
                >
                  <Select
                    placeholder="ເລືອກແຂວງ"
                    optionFilterProp="children"
                    onChange={p => {
                      let provice_id = provice.find(e => e.provice_name === p)
                      setproviceid(provice_id.provice_id)
                      setproviceSelect(p)
                      // console.log(p, provice_id.provice_id)
                    }}
                    className='TI'
                    style={{ width: '100%' }}
                  >
                    {
                      provice.map((v) => {
                        return (
                          <Option key={v.provice_id} value={v.provice_name}>{v.provice_name}</Option>
                        )
                      })
                    }

                  </Select>
                </Form.Item>
              </div>
              <div className='col'>
                <Form.Item
                  className='mb-0'
                  // label="ທີ່ຢູ່ເມືອງ"
                  name="addressDist"
                >
                  <Select
                    placeholder="ເລືອກເມືອງ"
                    optionFilterProp="children"
                    onChange={(e) => {
                      setdistSelect(e)
                    }}
                    className='TI'
                    style={{ width: '100%' }}
                  >
                    {
                      dist.map((v) => {
                        return (
                          <Option key={v.dist_id} value={v.dist_name}>{v.dist_name}</Option>
                        )
                      })
                    }

                  </Select>
                </Form.Item>
              </div>
              <div className='col'>
                <Form.Item
                  className='mb-0'
                  // label="ພິມຊື່ບ້ານ"
                  name="addressVill"
                >
                  <Input className='TI' placeholder="ພິມຊື່ບ້ານ"
                  // onChange={v => { setvillageSelect(v.target.value) }}
                  />
                </Form.Item>
              </div>
            </div>
            <Form.Item
              className='mb-0'
              // label="ໂທລະສັບ"
              name="phone"
            >
              <Input className='TI' placeholder="ໂທລະສັບ"
              // onChange={(e) => { seto_tel(e.target.value) }}
              />
            </Form.Item>
            <Form.Item
              className='mb-0'
              // label="ປະເພດລົດ"
              name="typeCar"
            >
              <Select
                placeholder="ປະເພດລົດ"
                optionFilterProp="children"
                onChange={e => {
                  seto_type(e)
                }}
                className='TI'
                style={{ width: '100%' }}
              >
                {
                  listData.map((v) => {
                    return (
                      <Option key={v.name} value={v.name}>{v.name}</Option>
                    )
                  })
                }
              </Select>
            </Form.Item>
            <Form.Item
              className='mb-0'
              // label="ຫຍີ່ຫໍ້"
              name="make"
            >
              <Input className='TI' placeholder="ຫຍີ່ຫໍ້"
              // onChange={(e) => { seto_make(e.target.value) }}
              />
            </Form.Item>
            <Form.Item
              className='mb-0'
              // label="ເລກທະບຽນ"
              name="plate"
            >
              <Input className='TI' placeholder="ເລກທະບຽນ"
              // onChange={(e) => {                  seto_plate(e.target.value)                }}
              />
            </Form.Item>
            <Form.Item
              className='mb-0'
              // label="ສີລົດ"
              name="color"
            >
              <Input className='TI' placeholder="ສີລົດ"
              // onChange={(e) => { seto_color(e.target.value) }}
              />
            </Form.Item>
            <Form.Item
              className='mb-0'
              // label="ຄວາມແຮງເປັນ ເຊເຊ"
              name="power"
            >
              <Input className='TI' placeholder="ຄວາມແຮງເປັນ ເຊເຊ"
              // onChange={(e) => {                  seto_power(e.target.value)                }}
              />
            </Form.Item>
            <Form.Item
              className='mb-0'
              // label="ເລກຈັກ"
              name="engine"
            >
              <Input className='TI' placeholder="ເລກຈັກ"
              // onChange={(e) => { seto_engine(e.target.value) }}
              />
            </Form.Item>
            <Form.Item
              className='mb-0'
              // label="ເລກຖັງ"
              name="chassis"
            >
              <Input className='TI' placeholder="ເລກຖັງ"
              // onChange={(e) => { seto_chassis(e.target.value) }}
              />
            </Form.Item>
            <Form.Item
              className='mb-0'
              // label="ນ້ຳໜັກຄິດໄລ່ເປັນໂຕນ"
              name="weight"
            >
              <InputNumber className='TIN' min={0} placeholder="ນ້ຳໜັກຄິດໄລ່ເປັນໂຕນ" max={60}
              //   onChange={(e) => { seto_weight(e) }}
              />
            </Form.Item>
            <Form.Item
              className='mb-0'
              // label="ຈຳນວນບ່ອນນັ່ງ"
              name="seats"
              rules={[{ required: true, message: 'ກະລຸນາເລືອກເພີ່ມຈຳນວນບ່ອນນັ່ງ' }]}
            >
              <InputNumber className='TIN' min={2} max={50} placeholder="ຈຳນວນບ່ອນນັ່ງ"
              //   onChange={(e) => { seto_seats(e) }}
              />
            </Form.Item>


          </Card>
          <Card className='C'>
            <Divider orientation="left" plain>
              ເລືອກປະເພດແພັກແກັດ
            </Divider>
            <Form.Item
              className='mb-0'
              // label="ກະລຸນາເລືອກທາງເລືອກ"
              name="package"
              rules={[{ required: true, message: 'ກະລຸນາເລືອກແພັກເກັດເສຍກ່ອນ' }]}
            >
              <Select
                placeholder="ກະລຸນາເລືອກທາງເລືອກ"
                optionFilterProp="children"
                onChange={onChange_Car}
                className='SCP'
              >
                {data.map((v) => {
                  return (
                    <Option key={v.id} value={v.id}>{v.name}</Option>
                  )
                })}
              </Select>
            </Form.Item>
          </Card>


          <Card className='C'>
            <Divider orientation="left" plain>
              ປະເພດຂອງສັນຍາປະກັນໄພ
            </Divider>
            ພາກທີ 1: ການປະກັນໄພ ທາງແພ່ງຕໍ່ບຸກຄົນທີສາມ

            <Radio.Group onChange={(e) => seta_used(e.target.value)} value={a_used} className='R'>
              <Radio value={'private'}>ລົດສ່ວນຕົວ</Radio>
              <Radio value={'business'}>ຮັບຈ້າງ</Radio>
            </Radio.Group>

            <Radio.Group onChange={e => seta_type(e.target.value)} value={a_type} className='R'>
              <Radio value={'new'}>ສັນຍາໃໝ່</Radio>
              <Radio value={'renew'}>ຕໍ່ສັນຍາ</Radio>
            </Radio.Group>

          </Card>
          <Card className='C'>
            <Divider orientation="left" plain>
              ຄິດໄລຄ່າທຳນຽມ
            </Divider>
            <div className='B'>
              <div className='B1'> ຄ່າທຳນຽມຕົວຈິງບໍ່ທັນລວມອາກອນ </div>
              <div className='B2'>{format(premuim)}</div>
            </div>
            <div className='B'>
              <div className='B1'> ອາກອນມູນຄ່າເພີ່ມ </div>
              <div className='B2'>{format(vat)}</div>
            </div>
            <div className='B'>
              <div className='B1'> ຄ່າຂື້ນທະບຽນ </div>
              <div className='B2'>{format(register)}</div>
            </div>
            <div className='B'>
              <div className='B1'> ລວມມູນຄ່າຕ້ອງຈ່າຍ </div>
              <div className='B2'>{format(total_premuim)}</div>
            </div>
          </Card>
          <Card className='C'>
            <Divider orientation="left" plain>
              ການຊຳລະເງິນ
            </Divider>
            <div className='BDP'>
              <div className='B1DP'>ສະຖານະການຊຳລະ</div>
              <div className='B2DP'>

                <Radio.Group onChange={(e) => {
                  setemp_paid(e.target.value);
                }} value={emp_paid}>
                  <Radio value={0}>ລໍຖ້າການຊຳລະ</Radio>
                  <Radio value={1}>ຊຳລະສົມບູນ</Radio>
                </Radio.Group>

              </div>
            </div>
          </Card>
          <br />
          *ເພີ່ມວັນສິ້ນສຸດດ້ວຍຕົນເອງ  <span style={{ color: 'red' }}> (ຖ້າປິດສັນຍາຈະຄຸ້ມກັນເປັນເວລາ 1 ປີ) </span>
          <Switch
            checked={addEnd}
            checkedChildren="ປິດ"
            unCheckedChildren="ເປີດ"
            onChange={(e) => {
              setAddEnd(e)
              form.setFieldsValue({ start: '' })
              form.setFieldsValue({ end: '' })
            }}
          />
          <div className='BDP mt-2'>
            <div className='B1DP'>
              <Form.Item

                label="ວັນທີເລີ່ມຄຸ້ມກັນ ::"
                name="start"
                rules={[{ required: true, message: 'ກະລຸນາເລືອກ ວັນທີເລີ່ມຄຸ້ມກັນ ເສຍກ່ອນ' }]}
              >
                <DatePicker
                  placeholder='ວັນທີເລີ່ມຄຸ້ມກັນ'
                  className='DP'
                  showTime onChange={onChange_timestart}
                  format={dateFormat}
                  disabledDate={(current) => current.isBefore(moment().subtract(1, "day"))}
                />
              </Form.Item>
            </div>
            {
              addEnd && <div className='B2DP'>
                <Form.Item
                  label=" ວັນທີສຶ້ນສຸດຄຸ້ມກັນ::"
                  name="end"
                  rules={[{ required: true, message: 'ກະລຸນາເລືອກ  ວັນທີສຶ້ນສຸດຄຸ້ມກັນ ເສຍກ່ອນ' }]}
                >
                  <DatePicker
                    placeholder='ວັນທີສຶ້ນສຸດຄຸ້ມກັນ'
                    className='DP'
                    showTime
                    onChange={onChange_timeend}
                    format={dateFormat}
                  />
                </Form.Item>
              </div>

            }
            {/* <div className='B2DP'>
              <Form.Item

                label=" ວັນທີສຶ້ນສຸດຄຸ້ມກັນ::"
                name="end"
                rules={[{ required: true, message: 'ກະລຸນາເລືອກ  ວັນທີສຶ້ນສຸດຄຸ້ມກັນ ເສຍກ່ອນ' }]}
              >
                <DatePicker
                  placeholder='ວັນທີສຶ້ນສຸດຄຸ້ມກັນ'
                  className='DP'
                  showTime onChange={onChange_timeend}
                  format={dateFormat}
                />
              </Form.Item>
            </div> */}
          </div>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              style={{ width: '100%' }}
            >
              ບັນທຶກຂໍ້ມູນ
            </Button>
          </Form.Item>
        </Form>

        <br />
        <br />
      </div>
    )
  }
}

export function Spinshow() {
  return (
    <div className="fullscreenDiv">
      <div className="center">
        <Spin tip="ກະລຸນາລໍຖ້າ..." />
      </div>
    </div>
  )
}


export default Sellpac;